import React from 'react';
import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';

const ArrowSecondaryBottomLeftIcon = (props) => (
  <SvgIcon viewBox="0 0 16 16" {...props}>
    <path
      d="M3.83791 12.2757C3.95853 12.3963 4.12592 12.4699 4.31024 12.4699L9.643 12.4699C10.0112 12.4704 10.3096 12.172 10.3096 11.8033L10.3096 11.7223C10.3101 11.3541 10.0116 11.0557 9.643 11.0557L6.00066 11.0557L12.1621 4.89431C12.4223 4.63409 12.4223 4.21171 12.1621 3.9515C11.9019 3.69128 11.4795 3.69128 11.2193 3.9515L5.05785 10.1129L5.05785 6.47057C5.05833 6.1024 4.7599 5.80397 4.39126 5.80397L4.31024 5.80397C3.94207 5.8035 3.64364 6.10193 3.64364 6.47057L3.64364 11.8033C3.64341 11.9874 3.71729 12.155 3.83791 12.2757Z"
      fill={props.sx?.color || '#080F1D'}
    />
  </SvgIcon>
);

ArrowSecondaryBottomLeftIcon.propTypes = {
  sx: PropTypes.object,
};

export default ArrowSecondaryBottomLeftIcon;
